import { clearFCMTokenFromBackend } from '@/services/firebase'

// Prevent re-entry if kick is already in progress
let kickInProgress = false

/**
 * Dispatch a global event that signals the agent's session was revoked.
 * Called from anywhere a 401 is detected while an agent_token exists.
 */
export function dispatchAgentKick () {
  window.dispatchEvent(new CustomEvent('agent-session-kicked'))
}

/**
 * Full cleanup + redirect for a kicked agent.
 * Navigates FIRST (while token still exists so the router guard doesn't interfere),
 * then clears FCM token and localStorage after navigation settles.
 * @param {import('vue-router').Router} router
 */
export async function kickAgent (router) {
  if (kickInProgress) return
  kickInProgress = true

  try {
    // Navigate first — token still in localStorage so the guard passes cleanly
    await router.replace('/agent/kicked')
  } catch (_) {
    // NavigationDuplicated or similar — already on kicked screen
  } finally {
    // Clear FCM token from backend (best-effort, non-blocking)
    const agentToken = localStorage.getItem('agent_token')
    if (agentToken) clearFCMTokenFromBackend(agentToken).catch(() => {})

    // Wipe local auth state
    localStorage.removeItem('agent_token')
    localStorage.removeItem('agent_data')
    localStorage.removeItem('auth_token')

    kickInProgress = false
  }
}
